// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={656}
      height={768}
      viewBox="-1.597 -1.597 56.43 66.108"
      {...props}
    >
      <path
        d="M13.935 48.678H.369v-1.706h6.047V8.14H.37V6.433h15.039l12.467 33.192-4.017 10.447L8.198 8.837v38.136h5.737v1.706M47.267 46.972h5.97v1.706H33.778v-1.706h5.968V8.76l-7.076 18.4-.971-2.629 7.118-18.098h14.418V8.14h-5.968v38.833"
        fill="#333"
      />
      <path
        d="M6.416 0h16.279l9.984 27.139-4.074 10.586L15.02 1.55H6.416V0"
        fill="#ffcd02"
      />
      <path
        d="M0 62.79h1.245v-5.924l.019-.021L3.01 62.79h1.245l1.748-5.945h.018v5.945h1.245v-7.204H5.185l-1.542 5.46h-.02l-1.542-5.46H0v7.204"
        fill="#333"
      />
      <path
        d="M8.661 58.94c.418-.35.948-.578 1.478-.578.734 0 1.077.29 1.077 1.145h-.687c-.52 0-1.134.053-1.608.31-.473.26-.817.723-.817 1.518 0 1.011.827 1.579 1.672 1.579.566 0 1.19-.33 1.478-.919h.019c.008.166.008.516.055.795h1.097a24.106 24.106 0 0 1-.056-1.186c-.009-.393-.019-.795-.019-1.333v-.681c0-1.569-.604-2.239-2.063-2.239-.53 0-1.18.155-1.663.403l.037 1.186zm.632 2.313c0-.816.827-.92 1.385-.92h.538c0 .413-.055.796-.26 1.095a1.026 1.026 0 0 1-.873.475c-.447 0-.79-.197-.79-.65"
        fill="#333"
        fillRule="evenodd"
      />
      <path
        d="M13.352 62.79h1.245v-2.601c0-.681.196-1.765 1.097-1.765.798 0 .809.877.809 1.527v2.839h1.244v-3.354c0-1.197-.492-2.085-1.626-2.085-.65 0-1.18.238-1.57.846h-.018v-.722h-1.18v5.315M18.802 62.79h1.245v-2.601c0-.681.195-1.765 1.097-1.765.799 0 .809.877.809 1.527v2.839h1.245v-3.354c0-1.197-.493-2.085-1.627-2.085-.651 0-1.18.238-1.571.846h-.017v-.722h-1.18v5.315M24.251 62.79h1.245v-2.601c0-.681.195-1.765 1.098-1.765.798 0 .807.877.807 1.527v2.839h1.245v-3.354c0-1.197-.492-2.085-1.626-2.085-.65 0-1.189.33-1.505.846h-.019V55.05h-1.245v7.741"
        fill="#333"
      />
      <path
        d="M30.584 59.611c.056-.712.409-1.248 1.106-1.248.696 0 .975.577 1.012 1.248h-2.118zm2.955 1.755c-.465.289-.985.537-1.589.537-.771 0-1.31-.486-1.366-1.342h3.308c0-1.858-.502-3.21-2.277-3.21-1.486 0-2.22 1.269-2.22 2.808 0 1.744.92 2.755 2.499 2.755.67 0 1.19-.144 1.645-.423v-1.125M34.671 62.79h1.245v-5.315h-1.245v5.315zm0-6.285h1.245v-1.321h-1.245v1.321z"
        fill="#333"
        fillRule="evenodd"
      />
      <path
        d="M37.002 62.79h1.245v-2.58c0-.691.102-1.786.93-1.786.714 0 .714.702.714 1.197v3.169h1.247v-2.58c0-.691.1-1.786.928-1.786.715 0 .715.702.715 1.197v3.169h1.245v-3.354c0-1.187-.334-2.085-1.514-2.085-.586 0-1.208.299-1.496.939-.27-.66-.743-.939-1.412-.939-.465 0-1.032.217-1.422.867h-.018v-.743h-1.162v5.315"
        fill="#333"
      />
      <path
        d="M45.917 59.611c.057-.712.41-1.248 1.107-1.248.696 0 .975.577 1.012 1.248h-2.119zm2.956 1.755c-.465.289-.985.537-1.59.537-.77 0-1.31-.486-1.366-1.342h3.31c0-1.858-.503-3.21-2.278-3.21-1.486 0-2.22 1.269-2.22 2.808 0 1.744.92 2.755 2.498 2.755.67 0 1.19-.144 1.646-.423v-1.125"
        fill="#333"
        fillRule="evenodd"
      />
      <path
        d="M50.005 62.79h1.245v-1.95c0-.764 0-2.168 1.013-2.168.223 0 .446.042.557.113v-1.392c-.13-.042-.26-.042-.38-.042-.744 0-1.255.835-1.311 1.331h-.018v-1.207h-1.106v5.315"
        fill="#333"
      />
    </svg>
  );
};

const MannheimerIcon = Icon;
export default MannheimerIcon;
